import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { GetImsVendorLoadData } from '@/api/SubDeliveryNote';
import util from '@/libs/util';
import changeVendorDialog from './changeVendorDialog';
export default {
  components: {
    changeVendorDialog: changeVendorDialog
  },
  mounted: function mounted() {
    this.CREATORID = JSON.parse(util.cookies.get('userInfo')).USER_NAME;

    if (this.userInfo.PARENT_VENDOR_NAME) {
      this.isSubVendor = true;
    } else if (this.userInfo.TYPE_ID === '3' || this.userInfo.TYPE_ID === '1') {
      this.isSubVendor = false;
    }
  },
  data: function data() {
    return {
      formData: {
        DELIVERY_NO: null,
        // 送货单号
        CREATORID: null,
        // 制单人
        DESCRIPTION: null,
        // 备注
        // DELIVERY_DATE:null,
        // ARRIVAL_DATE:null,
        DELIVERY_DATE: util.formatTime.FormatDate(),
        // 出货日期
        ARRIVAL_DATE: util.formatTime.FormatDate(),
        // 到货日期
        VENDOR_CODE: util.getUserInfo().PARENT_VENDOR_CODE || null,
        // 供应商代码
        VENDOR_NAME: util.getUserInfo().PARENT_VENDOR_NAME || null // 供应商名称

      },
      // mode:'show',
      vendorOptions: [],
      selectLoading: false,
      Rules: {
        VENDOR_CODE: [{
          required: true,
          message: '供应商不能为空',
          trigger: ['blur', 'change']
        }],
        DELIVERY_DATE: [{
          required: true,
          message: '出货日期不能为空',
          trigger: 'blur'
        }],
        ARRIVAL_DATE: [{
          required: true,
          message: '到货日期不能为空',
          trigger: 'blur'
        }]
      },
      CREATORID: null,
      isShowSubDeliveryNoteChangeVendorDialog: false,
      // 显示选择供应商dialog
      userInfo: util.getUserInfo(),
      defaultTime: ['00:00:00', '00:00:00'],
      isSubVendor: false
    };
  },
  methods: {
    //校验是否有供应商代码
    valiVENDOR_CODE: function valiVENDOR_CODE() {
      var _this = this;

      return new Promise(function (resolve) {
        _this.$refs.formData.validateField('VENDOR_CODE', function (errorMessage) {
          // console.log('errorMessage', errorMessage)
          var bool = errorMessage === '';

          if (bool === true) {
            // this.Bus.emit('onShowAddRowDialog', this.formData.VENDOR_CODE)
            resolve(_this.formData.VENDOR_CODE);
          } else {
            resolve(false);
          }
        });
      });
    },
    handleARRIVAL_DATE: function handleARRIVAL_DATE(v) {
      // console.log('now',new Date());
      // console.log(new Date() < v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：到货日期早于当前系统日期');
      }
    },
    handleDay: function handleDay(v) {
      // console.log('now',new Date());
      // console.log(new Date() < v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：出货日期早于当前系统日期');
      }
    },
    // onBeforeShowAddRowDialogForaddOrder () {
    //   if (this.$SubDeliveryNoteState === 'addOrder') {
    //     this.$refs.formData.validateField('VENDOR_CODE', (errorMessage) => {
    //       console.log('errorMessage', errorMessage)
    //       const bool = errorMessage === ''
    //       if (bool === true) {
    //         this.Bus.emit('onShowAddRowDialog', this.formData.VENDOR_CODE)
    //       }
    //     })
    //   }
    // },
    // 供应商dialog确定
    cbDialogSubmit: function cbDialogSubmit(_ref) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vendorObj, dialogData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vendorObj = _ref.vendorObj, dialogData = _ref.dialogData;
                // console.log('vendorObj',vendorObj);
                // console.log('dialogData',dialogData);
                _this2.vendorOptions = dialogData.map(function (item) {
                  return {
                    key: item.Id,
                    value: item.Code,
                    label: item.Code + ' - ' + item.Name,
                    name: item.Name
                  };
                }); // this.formData.VENDOR_CODE = vendorObj.Code
                // this.getVendorList(vendorObj.Name)

                _this2.formData.VENDOR_CODE = vendorObj.Code;
                _this2.formData.VENDOR_NAME = vendorObj.Name;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭供应商选择dialog
    closeChangeVendorDialog: function closeChangeVendorDialog(value) {
      this.isShowSubDeliveryNoteChangeVendorDialog = value;
    },
    // 点击供应商选择
    handleChangeVendorBtn: function handleChangeVendorBtn() {
      var _this3 = this;

      this.isShowSubDeliveryNoteChangeVendorDialog = true;
      this.$nextTick(function () {
        _this3.$refs.changeVendorDialog.GetVendorList();
      });
    },
    validateHeader: function validateHeader() {
      var _this4 = this;

      // console.log('this.formData',this.formData);
      console.log('DELIVERY_DATE', Date.parse(this.formData.DELIVERY_DATE));
      console.log('ARRIVAL_DATE', Date.parse(this.formData.ARRIVAL_DATE));
      this.$refs.formData.validate(function (bool) {
        if (bool === true) {
          if (Date.parse(_this4.formData.DELIVERY_DATE) > Date.parse(_this4.formData.ARRIVAL_DATE)) {
            _this4.$message.warning('出货日期不能大于到货日期');

            return;
          }

          _this4.$emit('validateHeaderSuccess', _this4.formData);
        }
      });
    },
    handleChange: function handleChange() {
      var _this5 = this;

      // console.log('选择',this.formData.VENDOR_CODE);
      this.vendorOptions.forEach(function (v) {
        if (v.value === _this5.formData.VENDOR_CODE) {
          _this5.formData.VENDOR_NAME = v.name;
        }
      });
    },
    // 下拉框输入供应商
    handleInputVendorSelect: function handleInputVendorSelect(value) {
      // console.log(value);
      if (value !== '') {
        this.selectLoading = true;
        this.getVendorList(value);
      } else {}
    },
    getVendorList: function getVendorList() {
      var _arguments = arguments,
          _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var Key, params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Key = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Page: 1,
                  Limit: 20,
                  Key: Key
                };
                _context2.next = 4;
                return GetImsVendorLoadData(params);

              case 4:
                res = _context2.sent;
                // console.log('供应商列表 res',res);
                _this6.selectLoading = false;

                if (res.code === 0) {
                  _this6.vendorOptions = res.data.Items.map(function (item) {
                    return {
                      key: item.Id,
                      value: item.Code,
                      label: item.Code + ' - ' + item.Name,
                      name: item.Name
                    };
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  watch: {
    $SubDeliveryNoteState: {
      handler: function handler(nawValue) {
        var _this7 = this;

        // console.log('表头 单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'orderShow') {} else if (nawValue === 'listShow') {
          this.$nextTick(function () {
            _this7.$refs.formData.resetFields();
          });

          for (var key in this.formData) {
            this.formData[key] = null;
          }
        } else {}
      },
      immediate: true
    }
  },
  computed: {// ...mapGetters(['MaintainDeliveryNote2OrderState'])
  }
};